import { render, staticRenderFns } from "./Accred.vue?vue&type=template&id=aae0386e&scoped=true&"
import script from "./Accred.vue?vue&type=script&lang=js&"
export * from "./Accred.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae0386e",
  null
  
)

export default component.exports